var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Attachment',{ref:"attachment",attrs:{"name":_vm.name,"readonly":_vm.readonly,"view":_vm.view,"value":_vm.fileInfo},on:{"change":_vm.onChange,"fileChange":_vm.fileChange,"emitClear":_vm.emitClear}})}
var staticRenderFns = []

export { render, staticRenderFns }